import { Component } from '@angular/core';

@Component({
  selector: 'ao-oren-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ao-oren';
}
